module.exports = __webpack_public_path__ + "4b97026924fa0e1a3cfcb932a8ef2baa.jpg";